<script setup>
import { getI18n } from '@/plugins/i18n'
import { infoBoxToneEnum } from '@/stores/portal.store'

import InfoBox from '@/components/shared/InfoBox.vue'

const props = defineProps({
  summary: {
    type: String,
    required: true,
  },
  inline: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['details', 'recompute'])

const i18n = getI18n()
</script>

<template>
  <info-box :tone="infoBoxToneEnum.WARNING">
    <div class="row items-center" :class="props.inline ? 'q-gutter-x-sm' : 'no-wrap'">
      <div
        :class="props.inline ? 'row items-center q-gutter-x-sm' : 'col column cursor-pointer'"
        @click="props.inline || emit('details')"
      >
        <b class="ellipsis">{{ i18n.t('common.report.pendingTitle') }}</b>
        <span class="text-caption ellipsis">{{ props.summary }}</span>
      </div>
      <q-btn
        v-if="props.inline"
        flat
        dense
        no-caps
        color="primary"
        icon="mdi-format-list-bulleted"
        :label="i18n.t('common.details')"
        @click="emit('details')"
      />
      <q-btn
        flat
        dense
        no-caps
        color="primary"
        icon="mdi-refresh"
        :label="i18n.t('common.report.recompute')"
        @click="emit('recompute')"
      />
    </div>
  </info-box>
</template>
